import PageLayout from './PageLayout';

export default function ContactPage() {
  return (
    <PageLayout title="Contact">
      <p>Contact page coming soon.</p>
    </PageLayout>
  );
}
